import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import LoginPhoto from '../../assets/LoginPhoto.svg';

const AuthLayout = ({ title, description, children }) => {
  return (
    <Grid container sx={{ borderRadius: '5px', height: 'calc(100vh - 50px)', overflow: 'hidden' }}>
      {/* Left Section - Form */}
      <Grid
        item
        xs
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 5,
          background: 'var(--white)',
          flexGrow: 1, 
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Typography variant="h1" fontWeight="bold" sx={{ mb: 0.5 }}>
            {title}
          </Typography>
          <Typography variant="body1" sx={{ mb: 2.5 }}>
            {description}
          </Typography>

          {children}
        </Box>
      </Grid>

      {/* Right Section - Image */}
      <Grid
        item
        sx={{
          width: '40%',
          maxWidth: '600px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          component="img"
          src={LoginPhoto}
          sx={{
            width: '100%',
            height: '100vh',
            objectFit: 'cover', 
            display: 'block',
          }}
        />
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
